<template>
    <div v-if="showSection" class="SectionBorderTop grid-narrow-left-column">
        <div class="left"></div>
        <div class="right">
            <div class="row">
                <div class="col-sm-12 col-md-3">
                    <div v-if="hasForecastManagerComment">
                        <div class="SectionTitle">Forecast Manager comments/recommendations</div>
                        <div class="comment"><MultiLineText :text="forecast.comments" /></div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div v-if="forecastWindow && forecastWindow.supervisorComment">
                        <div class="SectionTitle">Export Manager comments/recommendations</div>
                        <div class="comment"><MultiLineText :text="forecastWindow.supervisorComment" /></div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3">
                    <div v-if="forecastWindow && forecastWindow.comment">
                        <div class="SectionTitle">Market comments/requests</div>
                        <div class="comment"><MultiLineText :text="forecastWindow.comment" /></div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3"><slot></slot></div>
            </div>
        </div>
    </div>
</template>
<script>
import { PROFILES } from "@/plugins/AccessUserPlugin";
import loader from "@/components/loader/loader";
import MultiLineText from "@/components/forecasts/elements/general/MultiLineText";

export default {
    components: { MultiLineText, loader },
    props: {
        forecast: {
            type: Object,
            required: true
        },
        forecastWindow: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            contributors: null,
            loading: false
        };
    },
    computed: {
        hasComments() {
            return this.hasForecastManagerComment || (this.forecastWindow && (this.forecastWindow.supervisorComment || this.forecastWindow.comment));
        },
        hasForecastManagerComment() {
            return (
                this.forecast &&
                this.forecast.comments &&
                !(this.isForecastZoneLevel && this.forecastWindow && this.forecastWindow.multiValidation && this.forecast.publishMode !== "all_zones")
            );
        },
        isForecastZoneLevel() {
            return this.hasAccessByProfile(PROFILES.ZONE_FORECASTER) || this.hasAccessByProfile(PROFILES.ZONE_READER);
        },
        showSection() {
            return this.hasComments || !this.isForecastZoneLevel;
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../css/forecasts";
</style>



// WEBPACK FOOTER //
// Comments.vue?fb59ee00